import { Autocomplete, TextField } from '@mui/material'
import {
    CandidateFilterCategory,
    RosterType,
    SearchIndexField,
} from '__generated__/graphql'
import { FilterWrapper } from 'recruiter/components/FilterWrapper'
import { useRosterSearchFilter } from 'recruiter/hooks'

const options = [{ value: RosterType.Mapping }, { value: RosterType.Search }]

export function RosterTypeFilter() {
    const { value, setValue } = useRosterSearchFilter(
        SearchIndexField.RosterType
    )

    const typeInFilter = value?.value?.string
        ? options.find((o) => o.value === value.value?.string) ?? null
        : null

    const handleTypeChange = (_, newValue: (typeof options)[number] | null) => {
        if (!newValue) {
            setValue(null)
            return
        }

        setValue({
            category: CandidateFilterCategory.All,
            value: { string: newValue.value },
        })
    }

    return (
        <FilterWrapper label="Search Type">
            <Autocomplete
                ChipProps={{ size: 'small' }}
                onChange={handleTypeChange}
                getOptionLabel={({ value }) => value}
                options={options}
                renderInput={(params) => (
                    <TextField {...params} placeholder="Search Types" />
                )}
                value={typeInFilter}
            />
        </FilterWrapper>
    )
}
